// SAR price icon for KSA market (country SA / Doubly "KSA")
      // data-currency is NOT a signal: the shop's currency is SAR in every market,
      // so only the selected country or an explicit switcher choice means KSA.
      (function syncCurrencySarClass() {
        let boundSelect = null;

        const isKsaMarket = (code) => {
          const raw = String(code || '').toUpperCase();
          return /\b(SAR|KSA)\b/.test(raw) || raw.trim() === 'SA';
        };

        const applyForCountry = () => {
          document.body.classList.toggle('currency-sar', document.body.dataset.country === 'SA');
        };

        const applyForSwitcher = (code) => {
          const raw = String(code || '').toUpperCase();
          const match = raw.match(/\b([A-Z]{3})\b/);
          const token = match ? match[1] : raw.trim();

          document.body.classList.toggle('currency-sar', isKsaMarket(raw));
          if (token) document.body.dataset.currency = token;
        };

        applyForCountry();

        const bindSelect = () => {
          const select = document.querySelector('select.currency-switcher');
          if (!select || select === boundSelect) return;
          boundSelect = select;
          applyForSwitcher(select.value);
          select.addEventListener('change', () => applyForSwitcher(select.value));
        };

        document.addEventListener('change', (event) => {
          const target = event.target;
          if (!(target instanceof HTMLSelectElement)) return;
          if (!target.matches('select.currency-switcher, .doubly-wrapper select')) return;
          applyForSwitcher(target.value);
        });

        const start = () => {
          bindSelect();
          const header = document.querySelector('#header-group, header-component');
          if (!header) return;
          const observer = new MutationObserver(bindSelect);
          observer.observe(header, { childList: true, subtree: true });
          setTimeout(() => observer.disconnect(), 10000);
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start);
        } else {
          start();
        }
      })();

      // Inline header height and menu style calculations to prevent layout shift
      // Note: Updates in calculateHeaderGroupHeight(), updateTransparentHeaderOffset() and setHeaderMenuStyle() utilities.js should be kept in sync with this function
      (function setHeaderHeighCustomProperties() {
        /*
         * Header calculation functions for maintaining CSS variables
         * Mimic calculateHeaderGroupHeight() in utilities.js
         */
        const header = document.querySelector('header-component');
        const headerGroup = document.querySelector('#header-group');
        const hasHeaderSection = headerGroup?.querySelector('.header-section');

        if (!header || !headerGroup) return;

        const headerTopRow = header.querySelector('.header__row--top');
        const headerHeight = header.offsetHeight;

        // Calculate the total height of the header group
        let headerGroupHeight = 0;
        const children = headerGroup.children;
        for (let i = 0; i < children.length; i++) {
          const element = children[i];
          if (element === header || !(element instanceof HTMLElement)) continue;
          headerGroupHeight += element.offsetHeight;
        }

        // Check for transparent header special case
        if (header.hasAttribute('transparent') && header.parentElement?.nextElementSibling) {
          headerGroupHeight += headerHeight;
        }

        // Set CSS variables
        document.body.style.setProperty('--header-height', `${headerHeight}px`);
        document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);

        if (headerTopRow) {
          window.requestAnimationFrame(function () {
            document.body.style.setProperty('--top-row-height', `${headerTopRow.offsetHeight}px`);
          });
        }

        /**
         * Updates CSS custom properties for transparent header offset calculation
         * Mimic updateTransparentHeaderOffset() in utilities.js
         */

        if (!hasHeaderSection || !header?.hasAttribute('transparent')) {
          document.body.style.setProperty('--transparent-header-offset-boolean', '0');
          return;
        }

        const hasImmediateSection = hasHeaderSection.nextElementSibling?.classList.contains('shopify-section');

        const shouldApplyOffset = !hasImmediateSection ? '1' : '0';
        document.body.style.setProperty('--transparent-header-offset-boolean', shouldApplyOffset);
      })();

      (function setHeaderMenuStyle() {
        const headerComponent = document.querySelector('#header-component');
        if (headerComponent) {
          const isTouchDevice = 'ontouchstart' in window && navigator.maxTouchPoints > 0;
          const overflowList = headerComponent?.querySelector('overflow-list');
          const hasReachedMinimum = overflowList && overflowList.hasAttribute('minimum-reached');
          headerComponent.dataset.menuStyle = isTouchDevice || hasReachedMinimum ? 'drawer' : 'menu';
        }
      })();
